module.exports = __webpack_public_path__ + "img/banner_2.db1c2fec.jpg";